var map = {
	"./AccountManagementPage": 4604,
	"./AuthenticationFailurePage": 71800,
	"./BuyerCleaningPage": 99050,
	"./BuyerDetailsPage": 64672,
	"./BuyerRedirectPage": 70353,
	"./BuyerRelationshipPage": 30933,
	"./BuyersPage": 71752,
	"./CallOffIdentifierRuleEditor": 38234,
	"./CallOffIdentifierRulesPage": 78864,
	"./ContactsPage": 43738,
	"./CreateAccountCustomHeader": 86195,
	"./CreateAccountPage": 58421,
	"./CustomBriefingsPage": 6302,
	"./DocumentDetailsPage": 47099,
	"./DocumentsPage": 55248,
	"./EmailConfirmationPage": 50629,
	"./EmailVerificationPage": 71383,
	"./ExpiredGuestPass": 39977,
	"./FrameworkDetailsPage": 8476,
	"./FrameworkListPage": 58287,
	"./GuestPassBuyerDetailsPage": 73151,
	"./GuestPassSupplierProfilePage": 48056,
	"./HomepagePage": 17988,
	"./IndustryReportsPage": 2684,
	"./InvitationExpiredPage": 80545,
	"./MyBidsPage": 92435,
	"./MyFeedPage": 52525,
	"./MyNoticesPage": 36327,
	"./NoticeDetailsPage": 33709,
	"./NoticesAnalysisPage": 215,
	"./OnboardingPage": 13727,
	"./OpportunitiesPage": 58620,
	"./OpportunityPage": 30715,
	"./OscarSearchPage": 10773,
	"./PreAuthenticationScreen": 86352,
	"./PreSignupEmailVerificationPage": 81100,
	"./PrintReportPage": 88841,
	"./ReportPage": 31782,
	"./SpendDataPage": 29620,
	"./SupplierBuyerRelationshipPage": 36017,
	"./SupplierCleaningPage": 5839,
	"./SupplierListPage": 94379,
	"./SupplierProfilePage": 36601,
	"./SupplierRelationshipPage": 80278,
	"./SupplierSearchPage": 96858,
	"./UnsubscribePage": 14288,
	"./UploadDocumentPage": 13191,
	"./VerticalViews": 94835,
	"pages/app/AccountManagementPage": 4604,
	"pages/app/AuthenticationFailurePage": 71800,
	"pages/app/BuyerCleaningPage": 99050,
	"pages/app/BuyerDetailsPage": 64672,
	"pages/app/BuyerRedirectPage": 70353,
	"pages/app/BuyerRelationshipPage": 30933,
	"pages/app/BuyersPage": 71752,
	"pages/app/CallOffIdentifierRuleEditor": 38234,
	"pages/app/CallOffIdentifierRulesPage": 78864,
	"pages/app/ContactsPage": 43738,
	"pages/app/CreateAccountCustomHeader": 86195,
	"pages/app/CreateAccountPage": 58421,
	"pages/app/CustomBriefingsPage": 6302,
	"pages/app/DocumentDetailsPage": 47099,
	"pages/app/DocumentsPage": 55248,
	"pages/app/EmailConfirmationPage": 50629,
	"pages/app/EmailVerificationPage": 71383,
	"pages/app/ExpiredGuestPass": 39977,
	"pages/app/FrameworkDetailsPage": 8476,
	"pages/app/FrameworkListPage": 58287,
	"pages/app/GuestPassBuyerDetailsPage": 73151,
	"pages/app/GuestPassSupplierProfilePage": 48056,
	"pages/app/HomepagePage": 17988,
	"pages/app/IndustryReportsPage": 2684,
	"pages/app/InvitationExpiredPage": 80545,
	"pages/app/MyBidsPage": 92435,
	"pages/app/MyFeedPage": 52525,
	"pages/app/MyNoticesPage": 36327,
	"pages/app/NoticeDetailsPage": 33709,
	"pages/app/NoticesAnalysisPage": 215,
	"pages/app/OnboardingPage": 13727,
	"pages/app/OpportunitiesPage": 58620,
	"pages/app/OpportunityPage": 30715,
	"pages/app/OscarSearchPage": 10773,
	"pages/app/PreAuthenticationScreen": 86352,
	"pages/app/PreSignupEmailVerificationPage": 81100,
	"pages/app/PrintReportPage": 88841,
	"pages/app/ReportPage": 31782,
	"pages/app/SpendDataPage": 29620,
	"pages/app/SupplierBuyerRelationshipPage": 36017,
	"pages/app/SupplierCleaningPage": 5839,
	"pages/app/SupplierListPage": 94379,
	"pages/app/SupplierProfilePage": 36601,
	"pages/app/SupplierRelationshipPage": 80278,
	"pages/app/SupplierSearchPage": 96858,
	"pages/app/UnsubscribePage": 14288,
	"pages/app/UploadDocumentPage": 13191,
	"pages/app/VerticalViews": 94835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18853;